if (('.js-alert').length) {
  setTimeout(() => $('.js-alert').fadeOut(500), 3000);
}
